export const APS_CLIENT_INITIALIZE = "APS_CLIENT_INITIALIZE";
export const APS_CLIENT_REINITIALIZE = "APS_CLIENT_REINITIALIZE";
export const APS_CLIENT_IFRAME_SIZE = "APS_CLIENT_IFRAME_SIZE";
export const APS_INITIALIZE = "APS_INITIALIZE";
export const APS_CART_UPDATE = "APS_CART_UPDATE";
export const APS_CART_APPLY_CREDITS = "APS_CART_APPLY_CREDITS";
export const APS_CART_APPLY_RESPONSE = "APS_CART_APPLY_RESPONSE";
export const APS_ERROR = "APS_ERROR";
export const APS_CART_CANCEL = "APS_CART_CANCEL";
export const APS_CART_CANCEL_RESPONSE = "APS_CART_CANCEL_RESPONSE";
export const APS_PROFILE_RESPONSE = "APS_PROFILE_RESPONSE";

export const APS_ERROR_CREDIT_REJECTED = "APS_ERROR_CREDIT_REJECTED";
export const APS_ERROR_CREDIT_CHANGED = "APS_ERROR_CREDIT_CHANGED";
export const APS_ERROR_CREDIT_CANCEL_REJECTED = "APS_ERROR_CREDIT_CANCEL_REJECTED";